function JoyTycoonCumBox(config,resources) {
  myPixiElement.container.call(this);


  this.config = $.extend(true,{
        img_border:"cumBox",
        img_fill:"cumFill",
        live_max:3,
        pos:[0,0],
        pos_fill:[-52,110],
  },config);
  this.x=this.config.pos[0];
  this.y=this.config.pos[1];
  this.storage={live:this.config.live_max};
  this.addChild(new myPixiElement.img({anchor:[1,0],img:this.config.img_border}));
  this.progressBar = new myPixiBar({
        texture_name:this.config.img_fill,
        anchor:[0.5,0.5],
        pos:this.config.pos_fill,
        vertical:true,
        val:this.config.live_max-this.storage.live,
        val_max:this.config.live_max+1
    },resources);
    this.addChild(this.progressBar);
    var thc=this;
    thc.updateView();
}
JoyTycoonCumBox.prototype = Object.create(myPixiElement.container.prototype);
JoyTycoonCumBox.prototype = $.extend(JoyTycoonCumBox.prototype, {
    updateView:function(){
        this.progressBar.updateVal(Math.max(0,this.config.live_max-this.storage.live));
    },
    getLive:function(){
        this.storage.live--;
        this.updateView();
        if(this.storage.live<0){
            return false;
        }
        return true;
    },
});

